import api from './axios';

export const getDashboardOverviewApi = (params = {}) =>
  api.get('/admin/dashboard/overview', { params });

export const getDashboardMetricsApi = () => api.get('/admin/dashboard/metrics');
export const getOnboardingFunnelApi = () => api.get('/admin/dashboard/onboarding-funnel');
export const getStateDistributionApi = () => api.get('/admin/dashboard/state-distribution');
export const getPriorityAlertsApi = () => api.get('/admin/dashboard/priority-alerts');
export const getRecentCampaignsApi = (params = {}) =>
  api.get('/admin/dashboard/recent-campaigns', { params });
